import { getDateTimeColumn, convertDate } from "./DateTimeValidation";


const weekdaysDaytime = [
    {
        code: 'B966',
        price: 36.4,
        applicable: false,
        name:'Weekdays Daytime Travel Premium',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'B968',
        price: 82.5,
        name: 'First Person Seen Weekdays',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
];

const weekdaysDaytimeSacrifice = [
    {
        code: 'B996',
        price: 36.4,
        applicable: false,
        reason: '',
        name: 'Travel Weekdays Sacrifice of Office Hours',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
            
        },
    },
    {
        code: 'B998',
        price: 82.5,
        name: 'First Person Seen Weekdays Sacrifice of Hours',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            
            self.applicable = true;
            self.reason = '';
        }

    },
];

const weekdaysEvening = [
    {
        code: 'B966',
        price: 36.4,
        applicable: false,
        name: 'Weekday Evening Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
            
        },
    },
    {
        code: 'B988',
        price: 82.5,
        name: 'First Person Seen Weekday Evenings',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            
            self.applicable = true;
            self.reason = '';
        }

    },
];


const weekendOrHolidays = [
    {
        code: 'B966',
        price: 36.4,
        applicable: false,
        name: 'Weekend Daytime Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
            
        },
    },
    {
        code: 'B988',
        price: 82.5,
        name: 'First Person Seen Weekends',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            const x = newApt
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            
            self.applicable = true;
            self.reason = '';
        }

    },
];

const nights = [

    {
        code: 'B966',
        price: 36.4,
        applicable: false,
        name: 'Nightime Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'B988',
        price: 82.5,
        name: 'First Person Seen Nights',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
];


export function getPallativeCareColumn(newApt) {
    const dateObject = convertDate(newApt.date, newApt.time);
    const columnType = getDateTimeColumn(dateObject);

    // ['weekdaysDaytime','weekdaysEvening', 'nights', 'weekendOrHoliday']
    switch (columnType) {
        case 'weekdaysDaytime':
            if(newApt.sacrificeOfOfficeHours) return weekdaysDaytimeSacrifice;
            else return weekdaysDaytime;
        case 'weekdaysEvening':
            return weekdaysEvening;
        case 'nights':
            return nights;
        case 'weekendOrHoliday':
            return weekendOrHolidays;
    }
}

